import { renderModel } from '../../util/renderModel';
import { biLogger } from '../biLogger';
import { BiEventLogger } from '../types';
import { getRuntimeDataForBi } from '../utils';
import { RELATED_RESOURCES_COMPONENT_NAME } from './logRelatedResourceExposed';

export const VideoEngagementAction = {
  Play: 'play_video',
  Pause: 'pause_video',
} as const;

export const VideoPlayTrigger = {
  Autoplay: 'autoplay',
  Manual: 'manual',
} as const;

export type RelatedResourceVideoEngagementBiData = {
  requestId: string | undefined;
  itemName: string;
  position?: number;
  mediaUrls?: string;
  hostArticleId?: string;
  videoDuration?: number;
  clickedText: string;
  playTrigger: string;
};

/**
 * 4:1531 - the user interacted with a video in the related-resources modal: playback started or
 * was paused, confirmed through the YouTube IFrame API.
 */
export const logRelatedResourceVideoEngagement: BiEventLogger<RelatedResourceVideoEngagementBiData> = async (
  state,
  { requestId, itemName, position, mediaUrls, hostArticleId, videoDuration, clickedText, playTrigger },
) => {
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  await biLogger.chatbotRelatedResourceVideoEngagement(state, {
    session_id: sessionId,
    chatbot_view: contextBi?.chatbot_view,
    request_id: requestId,
    component_name: RELATED_RESOURCES_COMPONENT_NAME,
    item_type: 'video',
    item_name: itemName,
    position,
    media_urls: mediaUrls,
    host_article_id: hostArticleId,
    host_article_language: renderModel.getLocale(),
    video_duration: videoDuration,
    clicked_text: clickedText,
    play_trigger: playTrigger,
  });
};
